type IconName = 'bell' | 'live' | 'receipt' | 'purchase' | 'cancel' | 'share' | 'link';

export default function BuyerFeatureIcon({ name, size = 22 }: { name: IconName; size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
    {name === 'bell' && <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z" /><path d="M10 21h4" /></>}
    {name === 'live' && <><rect x="3" y="5" width="18" height="14" rx="3" /><path d="m10 9 5 3-5 3V9Z" /></>}
    {name === 'receipt' && <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z" /><path d="M9 7h6M9 11h6M9 15h3" /></>}
    {name === 'purchase' && <><path d="M5 7h14l1 14H4L5 7Z" /><path d="M9 8V6a3 3 0 0 1 6 0v2" /></>}
    {name === 'cancel' && <><path d="m8 4-4 4 4 4M4 8h10a6 6 0 0 1 0 12h-3" /></>}
    {name === 'share' && <><path d="M12 16V3m-5 5 5-5 5 5M6 12H4v9h16v-9h-2" /></>}
    {name === 'link' && <><path d="m10 13 4-4M8 15l-1 1a3.5 3.5 0 0 1-5-5l4-4a3.5 3.5 0 0 1 5 0m2 2 1-1a3.5 3.5 0 0 1 5 5l-4 4a3.5 3.5 0 0 1-5 0" transform="translate(1 0)" /></>}
  </svg>;
}
